import React, { useState } from 'react';
import CloseIcon from '../../assets/images/closeIcon.svg';
import DeleteIcon from '../../assets/images/DeleteIcon.svg';
interface AddNoteModalProps {
    onClose: () => void;
    noteId?: string;
    onSave: (note: string) => void;
}

const AddNoteModal: React.FC<AddNoteModalProps> = ({ onClose, onSave }) => {
    const [note, setNote] = useState('');

    const handleSave = () => {
        onSave(note);
        setNote('');
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg w-[30rem] p-6">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Add Notes
                    </h2>
                    <button
                        onClick={onClose}
                        data-testid="add-notes-close-button"
                    >
                        <img src={CloseIcon} />
                    </button>
                </div>

                <textarea
                    className="w-full h-40 rounded-lg border border-gray-300 p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
                    placeholder="Type your note here..."
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                ></textarea>

                <div className="flex items-center justify-between mt-4">
                    <button
                        className="flex items-center hover:bg-blue-100 rounded-full p-1"
                        onClick={onClose}
                        data-testid="add-note-delete-button"
                    >
                        <img src={DeleteIcon} />
                    </button>
                    <div className="flex space-x-4">
                        <button
                            className="px-4 py-2 bg-gray-200 rounded-3xl hover:bg-gray-300"
                            data-testid="add-note-cancel-button"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                        <button
                            className="px-4 py-2 bg-blue-500 text-white rounded-3xl hover:bg-blue-600"
                            data-testid="add-note-save-button"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddNoteModal;
